<div class="main-view-{{textDir}}">
  <fao-header title="{{ 'common.main.title' | translate }}" (onLanguageChange)="onLanguageChange($event)"></fao-header>
  <main>
    <div class="container">
      <router-outlet></router-outlet>
    </div>
  </main>
  <fao-footer></fao-footer>
</div>